import React, { Component } from "react";
import Modal from "../Modal/Modal";
import ModalIncidencias from "../Modal/ModalIncident";
import { withStyles } from "@material-ui/core/styles";
import style from "../../assets/jss/disal-main/components/TableOperativo";
import ModalQR from "../Modal/ModalQR";
import api from "../../Services/ApiURLBase";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { URLDashIncident } from "../../other/apis";
import Hidden from "@material-ui/core/Hidden";

import {
  EndpointDashWorkCollect,
} from "../../Services/EndPointOperation";
class table extends Component {
  constructor() {
    super();
    this.state = {
      id: "",
      name: "",
      number: "",
      dataModal: [],
      dataIncident: [],
      openModal1: false,
      openModal2: false,
      openModal3: false,
    };
  }
  handleOpenModal = async (e, idV, idP) => {
    const idPoint = e.target.dataset.position;
    const namePoint = e.target.dataset.namepoint;
    const position = e.target.dataset.position;
    await this.setState({
      openModal1: true,
      id: idPoint,
      name: namePoint,
    });
    const valueProgram = this.props.status === "programated" ? 0 : 1;
    
    if (idV === 0 && idP === 0) {
      await this.setState({ dataModal: [] });
    } else {
      const result = await EndpointDashWorkCollect(idV, position, valueProgram, this.props.miningSite);
      const reestructure = result.data.containers.map((res) => {
        let hasIncident = "Pendiente";
        if (res.hasIncident) {
          hasIncident = "Incorrecta";
        } else if (res.recollectionContainerId) {
          hasIncident = "Correcta";
        }

        let tempData = {
          containerId: res.containerId,
          containerModel: res.containerModel,
          residualSubtype: res.residualSubtype,
          weight: res.weight,
          volume: res.volume,
          hasIncident,
          photoBefore: res.photoBefore,
          photoAfter: res.photoAfter,
        };
        return tempData;
      });

      await this.setState({ dataModal: reestructure });
    }
  };
  handleClickModalIncident = async (e, idP) => {
    const idPoint = e.target.dataset.id;
    const namePoint = e.target.dataset.namepoint;
    const numberPoint = e.target.dataset.numberpoint;

    await this.setState({
      openModal3: true,
      id: idPoint,
      name: namePoint,
      number: numberPoint,
    });
    if (idP === 0) {
      await this.setState({ dataIncident: [] });
    } else {
      await api.get(URLDashIncident(idPoint)).then((res) => {
        this.setState({
          dataIncident: res.data.data.length === 0 ? [] : res.data.data[0],
        });
      });
    }
  };
  handleClose = () => {
    this.setState({
      openModal1: false,
    });
  };
  handleOpenModal2 = async (e) => {
    const idPoint = e.target.dataset.id;
    const namePoint = e.target.dataset.namepoint;
    const qrCode = e.target.dataset.qrcode;
    await this.setState({
      openModal2: true,
      qrCode,
      id: idPoint,
      name: namePoint,
    });
  };
  handleCloseModal2 = () => {
    this.setState({
      openModal2: false,
    });
  };
  handleCloseModal3 = () => {
    this.setState({
      openModal3: false,
    });
  };
  render() {
    return (
      <Hidden smDown>
        <TableContainer className={this.props.classes.contentTable}>
          <Table
            className={this.props.classes.tableGeneral}
            aria-label="simple table"
          >
            <TableHead>
              <TableRow className={this.props.classes.cellOperativo}>
                <TableCell>#</TableCell>
                <TableCell style={{ width: "200px" }}>Gerencia</TableCell>
                <TableCell className="text-overflow" style={{ width: "200px" }}>
                  Punto Generador
                </TableCell>
                {this.props.status === "programated" ? (
                  <TableCell>Vehículo</TableCell>
                ) : null}
                <TableCell
                  className={!this.props.open ? "showCell" : "hideCell"}
                >
                  Volumen
                </TableCell>
                <TableCell
                  className={!this.props.open ? " showCell" : " hideCell"}
                >
                  Peso (Kg.)
                </TableCell>
                <TableCell
                  className={!this.props.open ? " showCell" : " hideCell"}
                >
                  Completados
                </TableCell>

                <TableCell
                  className={!this.props.open ? " showCell" : " hideCell"}
                >
                  Segregación
                </TableCell>
                {this.props.status === "programated" ? null : (
                  <TableCell>Estatus</TableCell>
                )}

                {this.props.status === "programated" ? null : (
                  <TableCell
                    className={!this.props.open ? " showCell" : " hideCell"}
                  >
                    Incidentes
                  </TableCell>
                )}
                <TableCell
                  className={!this.props.open ? " showCell" : " hideCell"}
                >
                  Ver
                </TableCell>
                <TableCell
                  className={!this.props.open ? " showCell" : " hideCell"}
                >
                  Codigo QR
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.props.pageOfItems.map((data, index) => {
                let idP = data.collectPointId;
                let pos = data.position;
                let idV = data.vehicleId;
                return (
                  <TableRow key={index}>
                    <TableCell component="th" scope="row">
                      {data.collectPointNumber}
                    </TableCell>
                    <TableCell>{data.departmentName}</TableCell>
                    <TableCell>{data.collectPointName} </TableCell>
                    {this.props.status === "programated" ? (
                      <TableCell>{data.plateNumber} </TableCell>
                    ) : null}
                    <TableCell
                      className={!this.props.open ? "showCell" : "hideCell"}
                    >
                      {data.totalVolume === "-" ? "-" : parseFloat(data.totalVolume).toFixed(3)}
                    </TableCell>
                    <TableCell
                      className={!this.props.open ? "showCell" : "hideCell"}
                    >
                      {data.totalWeight === "-" ? "-" : parseFloat(data.totalWeight).toFixed(1)}
                    </TableCell>
                    <TableCell
                      component="th"
                      scope="row"
                      className={!this.props.open ? "showCell" : "hideCell"}
                    >
                      {data.complete}
                    </TableCell>
                    <TableCell
                      className={!this.props.open ? "showCell" : "hideCell"}
                    >
                      {data.segregatio}
                    </TableCell>
                    {this.props.status === "programated" ? null : (
                      <TableCell>
                        <span
                          className={
                            "status" +
                            (data.hasIncidents === 0
                              ? data.estatus === "Pendiente"
                                ? " background-yellow-secondary"
                                : data.estatus === "Finalizado"
                                ? " background-greenDark"
                                : data.estatus === "En proceso"
                                ? " background-sky-blue"
                                : " "
                              : " background-incident")
                          }
                          style={{
                            color: data.estatus === "-" ? "#000" : "#fff",
                          }}
                        >
                          {data.hasIncidents === 0 ? data.estatus : "Incidente"}
                        </span>
                      </TableCell>
                    )}

                    {this.props.status === "programated" ? null : (
                      <TableCell
                        className={
                          "cell-button " +
                          (!this.props.open ? "showCell" : "hideCell")
                        }
                      >
                        {data.collectPointNumber === "-" ? null : (
                          <div>
                            <button
                              type="button"
                              data-id={data.collectPointId}
                              data-namepoint={data.collectPointName}
                              data-numberpoint={data.collectPointNumber}
                              className={
                                "btn-table " +
                                (data.hasIncidents === 0 ? "disab" : " ")
                              }
                              disabled={data.hasIncidents === 0 ? true : false}
                              onClick={async (e) =>
                                await this.handleClickModalIncident(e, idP)
                              }
                            >
                              Ver
                            </button>
                          </div>
                        )}
                      </TableCell>
                    )}
                    <TableCell
                      className={
                        "cell-button " +
                        (!this.props.open ? "showCell" : "hideCell")
                      }
                    >
                      {data.collectPointNumber === "-" ? null : (
                        <div>
                          <button
                            type="button"
                            data-id={data.collectPointId}
                            data-namepoint={data.collectPointName}
                            data-position={pos}
                            className="btn-table"
                            onClick={async (e) =>
                              await this.handleOpenModal(e, idV, pos)
                            }
                          >
                            Ver
                          </button>
                        </div>
                      )}
                    </TableCell>
                    <TableCell
                      className={
                        "cell-button " +
                        (!this.props.open ? "showCell" : "hideCell")
                      }
                    >
                      {data.collectPointNumber === "-" ? null : (
                        <div>
                          <button
                            type="button"
                            data-id={data.collectPointNumber}
                            data-namepoint={data.collectPointName}
                            data-position={pos}
                            data-qrcode={data.qrCode}
                            className="btn-table"
                            onClick={async (e) =>
                              await this.handleOpenModal2(e)
                            }
                          >
                            Ver
                          </button>
                        </div>
                      )}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <Modal
            openModal1={this.state.openModal1}
            handleClose={this.handleClose}
            id={this.state.id}
            namePoint={this.state.name}
            datamodal={this.state.dataModal}
          />
          <ModalQR
            openModal2={this.state.openModal2}
            qrCode={this.state.qrCode}
            handleClose={this.handleCloseModal2}
            id={this.state.id}
            namePoint={this.state.name}
          />
          <ModalIncidencias
            openModal3={this.state.openModal3}
            handleClose={this.handleCloseModal3}
            id={this.state.id}
            pointNumber={this.state.number}
            namePoint={this.state.name}
            datamodal={this.state.dataIncident}
          />
        </TableContainer>
      </Hidden>
    );
  }
}
export default withStyles(style)(table);
